module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-content', [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', [_c('label', [_vm._v("请输入APPID/ID/产品名称")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-content', [(_vm.plist.length > 0) ? _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("广告投放名称")]), _vm._v(" "), _c('md-table-head', [_vm._v("投放的广告位数量")]), _vm._v(" "), _c('md-table-head', [_vm._v("投放的创意数量")]), _vm._v(" "), _c('md-table-head', [_vm._v("启用时间")]), _vm._v(" "), _c('md-table-head', [_vm._v("禁用时间")]), _vm._v(" "), _c('md-table-head', [_vm._v("投放状态")])], 1), _vm._v(" "), _vm._l((_vm.plist), function(item, index) {
    return _c('md-table-row', [_c('md-table-cell', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.space_num))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.creative_num))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.start_time))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.end_time))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.status == '1' ? '正常' : '禁用'))])], 1)
  })], 2) : _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("暂无信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter md-alignment-center"
  }, [_c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-dense md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goPrev($event)
      }
    }
  }, [_vm._v("上一页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-80 md-small-size-50 md-xsmall-size-50"
  }, [_c('md-field', [_c('label', [_vm._v("选择页码")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "page",
      "id": "page"
    },
    model: {
      value: (_vm.pdata.page),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "page", $$v)
      },
      expression: "pdata.page"
    }
  }, _vm._l((_vm.maxPage), function(item) {
    return _c('md-option', {
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-dense md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goNext($event)
      }
    }
  }, [_vm._v("下一页")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-8ffd5932"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ADdelivery.vue
// module id = 528
// module chunks = 0